"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";
import { useTheme } from "../theme-provider";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      /*
        Laid out rather than piled up. Sonner's default stacks concurrent
        toasts into one another — the front card readable, the rest showing as
        edges under it — and several screens raise two at once: a strategy
        save says what was saved and then starts a price run that reports its
        own progress. Under the default stack the card carrying the version
        the operator can go back to sat behind the progress one.
      */
      expand
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
